export default {
    key: "bay_log",
    sort:{
        field: "id",
        order: "desc"
    },
    export: ["excel"],
    sort_fields:[
        "id",
        "creDttm",
        "inTime",
        "outTime",
        "relatedRsr",
        "bayUpdateStatus"
    ],
    filters:{
        id:{},
        sessionId:{},
        requestStatus:{
            type:"select",
        },
        bayUpdateStatus:{},
        relatedRsr:{},
        brand:{},
        bayId:{},
        licensePlate:{},
        locId:{
            type: "select",
        },
        // mallId: {
        //     type: "select",
        // },
        inTime: {
          type: "daterange"
        },
        outTime: {
          type: "daterange"
        },
        creDttm: {
          type: "daterange"
        }
    },
    options:{
        requestStatus: {
            key: "common_status"
        },
        locId: {
            key: "cp_locs",
            label: "address",
            value: "station_code"
        },
        // mallId: {
        //     key: "cp_locs",
        //     label: "address",
        //     value: "mall_id",
        // }
    },
    fields:[
        {key: "id"},
        {key: "sessionId",
            type: "href",
            url: "bay_log/",
            url_key: [
                {
                    search_key: "sessionId",
                    row_key: "sessionId",
                    str: ""
                }
            ]
        },
        {key: "status"},
        {key: "requestStatus"},
        {key: "bayUpdateStatus"},
        {key: "relatedRsr",
            type: "href",
            url: "cp_rsr/",
            url_key: [
                {
                    search_key: "rsr_id",
                    row_key: "relatedRsr",
                    str: ""
                }
            ]
        },
        {key: "bayId",
            type: "href",
            url: "bay_log/",
            url_key: [
                {
                    search_key: "bayId",
                    row_key: "bayId",
                    str: ""
                }
            ]
        },
        {key: "brand"},
        {key: "licensePlate"},
        // {key: "image", type: "hrefweb"},
        {key: "imageLocalPath", type: "hrefweb"},
        {key: "locId"},
        {key: "mallId"},
        {key: "inTime", type:"datetime"},
        {key: "outTime", type:"datetime"},
        {key: "creDttm", type:"datetime"},
        {key: "errorCode"},
        {key: "response"},
    ]
}